"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var useWidgetContext_1 = require("../../../../../common/react/useWidgetContext");
var usePlatformConfig_1 = require("../../../../../common/react/usePlatformConfig");
var SummaryCarView_1 = require("../../../summary/components/summaryViews/SummaryCarView");
var SummaryContext_1 = require("../../../../common/context/SummaryContext");
var react_router_1 = require("react-router");
var Routes_1 = require("../../../../../common/enum/Routes");
var core_1 = require("@material-ui/core");
var useDealData_1 = require("../../../common/hooks/useDealData");
var VehicleSummary = function () {
    var _a, _b, _c;
    var dimensions = useWidgetContext_1.default().configuration.dimensions;
    var _d = core_1.useTheme().checkoutLite.summary, hideReservationDetails = _d.hideReservationDetails, hideDriveawayPrice = _d.hideDriveawayPrice;
    var history = react_router_1.useHistory();
    var redirectUnavailableDeal = react_1.useCallback(function () { return history.replace(Routes_1.Routes.DEAL_UNAVAILABLE, {}); }, []);
    var dealData = useDealData_1.default().dealData;
    var _e = usePlatformConfig_1.default().platformConfig, priceDisplay = _e.priceDisplay, complexModel = _e.platformFeatures.complexModel;
    if (!dealData) {
        return null;
    }
    if (!((_a = dealData.car) === null || _a === void 0 ? void 0 : _a.prices)) {
        redirectUnavailableDeal();
        return null;
    }
    var financeDisclaimerBreakdown = (_b = dealData.finance) === null || _b === void 0 ? void 0 : _b.breakdown;
    return (<SummaryContext_1.default.Provider value={{ dimensions: dimensions, priceDisplay: priceDisplay, financeDisclaimerBreakdown: financeDisclaimerBreakdown }}>
      <SummaryCarView_1.default complexModel={complexModel} car={dealData.car} financeSimulation={(_c = dealData.finance) === null || _c === void 0 ? void 0 : _c.simulation} priceDisplay={priceDisplay} isCarEditable={true} isExtendable={true} dimensions={dimensions} dealAttributes={dealData.attributes} hideReservationDetails={hideReservationDetails} hideDriveawayPrice={hideDriveawayPrice} expressionsOfInterest={dealData.expressionsOfInterest}/>
    </SummaryContext_1.default.Provider>);
};
exports.default = VehicleSummary;
